import React from 'react';
import i18n from 'i18n';
import clsx from 'clsx';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/core/styles/makeStyles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { PermissionHandleCheck } from 'containers/Groups/interfaces';
import styles from './styles';

const useStyles = makeStyles(styles);

interface PermissionCardItemProps {
  permission: string;
  pending: string[];
  handleCheck: PermissionHandleCheck;
}

const PermissionCardItem: React.FC<PermissionCardItemProps> = ({
  permission,
  pending,
  handleCheck,
}) => {
  const classes = useStyles();

  return (
    <Grid item xs={12} data-testid="permission-card-item">
      <FormControlLabel
        data-testid="permission-card-item-field"
        className={clsx(classes.permissionItem, {
          [classes.pending]: pending.includes(permission),
        })}
        control={
          <Checkbox
            size="small"
            name={permission}
            checked={handleCheck.exists(permission)}
            onChange={() => handleCheck.toggle(permission)}
          />
        }
        label={i18n.t(permission.toUpperCase())}
      />
    </Grid>
  );
};

export default PermissionCardItem;
